export const PAD_OUTPAINT_GLOBAL_ID = "PadOutpaint";
